import React from 'react';
// You might want an icon library like react-icons
import { FiAlertCircle } from 'react-icons/fi';

function ErrorDisplay({ message, className = '' }) {
    if (!message) {
        return null;
    }

    return (
        <div
            className={`p-3 mb-4 border border-red-400 bg-red-100 text-red-700 rounded-md text-sm flex items-center ${className}`}
            role="alert"
        >
            {/* Optional Icon */}
            <FiAlertCircle className="w-5 h-5 mr-2 flex-shrink-0" />
            <span className="flex-grow">{message}</span>
        </div>
    );
}

export default ErrorDisplay;
